// src/client/components/profile-manager/detail-view/ProfileDataSection.tsx

import InlineEditField from './InlineEditField';
import type { ProfileWithRelations } from '@shared/types';

interface ProfileDataSectionProps {
  profile: ProfileWithRelations;
  onUpdate: (updates: Partial<ProfileWithRelations>) => Promise<void>;
}

export default function ProfileDataSection({
  profile,
  onUpdate,
}: ProfileDataSectionProps) {
  return (
    <div className="border rounded-lg p-4 bg-white">
      <h3 className="text-lg font-semibold mb-4">Profile Data</h3>
      
      <InlineEditField
        label="Score"
        value={profile.score}
        onSave={(value) => onUpdate({ score: value as number })}
        type="number"
        placeholder="0-100"
      />
            
      <InlineEditField
        label="Industry"
        value={profile.industry}
        onSave={(value) => onUpdate({ industry: value as string })}
        type="text"
      />
      
      <InlineEditField
        label="CRMWeb ID"
        value={profile.crmwebId}
        onSave={(value) => onUpdate({ crmwebId: value as number })}
        type="number"
      />

      <InlineEditField
        label="Mautic ID"
        value={profile.mauticId}
        onSave={(value) => onUpdate({ mauticId: value as number })}
        type="number"
      />
    </div>
  );
}